import Grid from '@mui/material/Grid'
import _ from 'lodash'
import React, { useState } from 'react'
import { ImageryDataType } from 'src/utils/utils.types'
import { imageryData } from '../../../utils/Imagery.utils'
import {
	ButtonImagery,
	ButtonImageryPicker,
	CardContentImagery,
	GridImagery,
	Image,
	Panel,
	SubTitle,
} from './ImageryPicker.styles'
import { ItemProps } from './ImageryPicker.types'

interface Props {
	imagerySelected: ImageryDataType
	setImagerySelected: (imagerySelected: ImageryDataType) => void
}

const ImageryPicker = ({ imagerySelected, setImagerySelected }: Props) => {
	const [openImageryPicker, setOpenImageryPicker] = useState<boolean>(false)

	const handleChangeImageryPicker = (name: string) => {
		setImagerySelected(
			imageryData.find((e) => e.name === name) || imageryData[0],
		)
	}

	const Item = ({ imagery }: ItemProps) => {
		return (
			<ButtonImagery selected={imagerySelected.name === imagery.name}>
				<Image
					src={imagery.src}
					alt={imagery.name}
					onClick={() => handleChangeImageryPicker(imagery.name)}
				/>
			</ButtonImagery>
		)
	}

	return (
		<>
			<ButtonImageryPicker
				openImageryPicker={openImageryPicker}
				onClick={() => setOpenImageryPicker(!openImageryPicker)}
			>
				<Image src={imagerySelected.src} alt={imagerySelected.name} />
			</ButtonImageryPicker>
			{openImageryPicker && (
				<Panel>
					<CardContentImagery>
						<SubTitle gutterBottom>Map</SubTitle>
					</CardContentImagery>
					<GridImagery container spacing={2}>
						{_.map(
							imageryData,
							(imagery: ImageryDataType, i: number) => (
								<Grid item xs={6} key={i}>
									<Item imagery={imagery} />
								</Grid>
							),
						)}
					</GridImagery>
				</Panel>
			)}
		</>
	)
}

export default ImageryPicker
